let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kpct2")).then(() => parcelRequire('ksdj2'));